import dayjs from 'dayjs'

export function isoDateStrToDateOrNull(
  dateString?: string | null | undefined
): Date | null {
  if (dateString == null) {
    return null
  }
  return new Date(dateString)
}

export function dateToISO(date: Date | null): string | null {
  if (date === null) {
    return null
  }
  return dayjs(date).format('YYYY-MM-DD')
}

export function dateToISOString(date: Date | null): string | null {
  if (date === null) {
    return null
  }
  return dayjs(date).toISOString()
}

export function strToDateFormat(str: string | null | undefined): string | null {
  if (str === null || str === undefined) {
    return null
  }
  return dayjs(str).format('DD.MM.YYYY')
}

export const convertStringToBoolean = (value: string) => {
  switch (value) {
    case 'false':
    case 'no':
    case '0':
    case '':
    case null:
      return false

    default:
      return true
  }
}

export function getAge(dateString: any) {
  let today = new Date()
  let birthDate = new Date(dateString)
  let age = today.getFullYear() - birthDate.getFullYear()
  let m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  //console.log(age)
  return age
}
